module.exports = __webpack_public_path__ + "img/dl006x3.prt.674f7013.jpg";